export class LeagueResult {
    constructor(league, openLeagueHandler) {
        this.componentType = "League";
        this.id = league.id;
        this.name = league.name;
        this.sportId = league.sportId;
        this.sportName = league.sportName;
        this.openLeagueHandler = openLeagueHandler;
        this.entityType = "League";
        this.clickHandler = this.clickHandler.bind(this);
    }
    clickHandler(event) {
        this.openLeagueHandler(event, this);
    }
}
//# sourceMappingURL=LeagueResult.js.map